<div class="online-map-summary">
<!--  <arm-side-panel class="height-adjustment drop-shadow-gray-border  network-details right-sidebar"
                  [title]="viewToShowObject.title">-->
    <div id="details-view-container">
      <nothing-selected-summary  [hidden]="!viewToShowObject.noSelection"></nothing-selected-summary>

      <node-summary [selection]="selection" [hidden]="!viewToShowObject.nodeSelection"></node-summary>

      <voip-peer-summary [selection]="selection" [hidden]="!viewToShowObject.voipPeerSelection"></voip-peer-summary>

      <voip-peer-aggregation-summary [selection]="selection"
        [hidden]="!viewToShowObject.voipPeerAggregationSelection"></voip-peer-aggregation-summary>

      <connection-summary [selection]="selection" [hidden]="!viewToShowObject.connectionSelection"></connection-summary>

      <peer-connection-summary [selection]="selection" [hidden]="!viewToShowObject.peerConnectionSelection"></peer-connection-summary>

      <peer-connection-aggregation-summary [selection]="selection"
        [hidden]="!viewToShowObject.peerConnectionAggregationSelection"></peer-connection-aggregation-summary>
    </div>
<!--  </arm-side-panel>-->
</div>
